import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../config/siteConfig";
import "../css/about.scss";

function About() {
  return (
    <main id="main-content" className="about-page">
      <figure className="about-page__hero">
        <img
          src="/img/about-studio.jpg"
          alt="A sunlit design studio work table"
          width="1120"
          height="1400"
          decoding="async"
        />
        <figcaption>Useful objects, distinct voices, enduring stories.</figcaption>
      </figure>

      <header className="about-page__intro" aria-labelledby="about-title">
        <p className="about-page__eyebrow">About {siteConfig.brandName}</p>
        <h1 id="about-title">{siteConfig.tagline}</h1>
        <div className="about-page__lede">
          <p>{siteConfig.description}</p>
          <p>
            We bring together objects that are rooted in place, shaped by hand
            and made to be lived with. Each piece carries the marks of its maker
            and the landscape that informed it.
          </p>
        </div>
      </header>

      <section
        id="studio"
        className="about-page__chapter about-page__chapter--copy"
        aria-labelledby="studio-title"
      >
        <p className="about-page__index" aria-hidden="true">
          01
        </p>
        <div>
          <h2 id="studio-title">Studio</h2>
          <p>
            Our studio is a place to discover considered home and lifestyle pieces
            at an unhurried pace. The collection moves between the practical and
            the poetic: vessels, textiles, jewellery, tools and works for the
            wall.
          </p>
          <p>Our Hong Kong team is available {siteConfig.contact.openingHours}.</p>
          <Link className="about-page__link" to="/contact">
            Plan a visit <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </section>

      <section
        id="makers"
        className="about-page__chapter about-page__chapter--image"
        aria-labelledby="makers-title"
      >
        <figure>
          <img
            src="/img/about-home.jpg"
            alt="A bright contemporary Hong Kong dining space"
            width="1120"
            height="1400"
            decoding="async"
            loading="lazy"
          />
          <figcaption>Material, process and the maker's hand.</figcaption>
        </figure>
        <div className="about-page__chapter-copy">
          <p className="about-page__index" aria-hidden="true">
            02
          </p>
          <h2 id="makers-title">Makers</h2>
          <p>
            We select practical pieces from trusted production partners. Some
            preserve familiar techniques while others use modern materials and
            processes. What connects them is usefulness, proportion and care.
          </p>
          <Link className="about-page__link" to="/shop">
            Meet the collection <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </section>

      <section
        id="stories"
        className="about-page__chapter about-page__chapter--copy"
        aria-labelledby="stories-title"
      >
        <p className="about-page__index" aria-hidden="true">
          03
        </p>
        <div>
          <h2 id="stories-title">Stories</h2>
          <p>
            An object becomes richer when we know where it came from. We share
            the materials, people and places behind the collection so that every
            piece can begin a story of its own.
          </p>
          <p>
            Questions about a work or its maker are always welcome. Write to us
            at <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.
          </p>
        </div>
      </section>
    </main>
  );
}

export default About;
